/* TODO: t() */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import autobind from 'class-autobind';
import toElement from '../../support/helpers/toElement';

type ChangeEvent = { target: { checked: boolean } };

type Props = {
  name?: string;
  checked?: boolean;
  onChange?: (value: boolean, event: ChangeEvent) => void;
  disabled?: boolean;
};

class Checkbox extends Component<Props> {
  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  render() {
    let { disabled } = this.props;
    return (
      <span className="chk">
        <input
          disabled={disabled}
          ref="input"
          type="checkbox"
          {...this.props}
          onChange={this._onChange}
        />
        <span />
      </span>
    );
  }

  focus() {
    let input = toElement(ReactDOM.findDOMNode(this.refs.input), 'input');
    if (input) {
      input.focus();
    }
  }

  _onChange(event: ChangeEvent) {
    if (this.props.onChange) {
      this.props.onChange(event.target.checked, event);
    }
  }
}

export default Checkbox;
